export interface RuntimeConfig {
  environment: 'dev' | 'hml' | 'prd'
  marketplaceUrl: string
  /** GlitchTip DSN for the browser (public by design). Empty = monitoring off. */
  sentryDsn: string
  /** Image commit, sent as the release of each error. */
  version: string
}

declare global {
  interface Window {
    __WPONE_CONFIG__?: Partial<RuntimeConfig>
  }
}

/** Per-environment config comes from the container (/config.js), never from the build. */
export function getRuntimeConfig(): RuntimeConfig {
  const c = window.__WPONE_CONFIG__ ?? {}
  return {
    environment: c.environment ?? 'dev',
    marketplaceUrl: c.marketplaceUrl ?? 'https://unifecaf.com.br',
    sentryDsn: c.sentryDsn ?? '',
    version: c.version ?? 'dev',
  }
}
